import React, { useCallback, useEffect, useState } from "react";
import SnackChip from "../../SnackChip/SnackChip";
import { useTranslation } from "react-i18next";
import { CORE } from "../../../models/SurveyModels";
import images, {
  ImageMap,
  getImage,
  getTemplateImg,
} from "../../../assets/img/template";
import getClasses from "../../../utils/getClasses";
import imagesCulture from "../../../assets/img/template/culture/culture";
import imagesOrganization from "../../../assets/img/template/organization/organization";
import imagesEconomy from "../../../assets/img/template/economy/economy";
import imagesRegulation from "../../../assets/img/template/regulation/regulation";

require("./Step3.scss");

interface IStep3 {
  onChange: (value: string) => void;
  templateImage?: string;
  templateName?: string;
}

const Step3 = ({ onChange, templateImage, templateName }: IStep3) => {
  const { t } = useTranslation();
  const [filterCategory, setFilterCategory] = useState<CORE | "ALL">("ALL");
  const [selectedImage, setSelectedImage] = useState<string | undefined>("");
  const [imagesArray, setImagesArray] = useState<ImageMap | undefined>(images);

  const setFilter = useCallback((value: CORE | "ALL") => {
    setFilterCategory(value);
    switch (value) {
      case "ALL":
        setImagesArray(images);
        break;
      case CORE.C:
        setImagesArray(imagesCulture);
        break;
      case CORE.O:
        setImagesArray(imagesOrganization);
        break;
      case CORE.R:
        setImagesArray(imagesRegulation);
        break;
      case CORE.E:
        setImagesArray(imagesEconomy);
        break;
      default:
        break;
    }
  }, []);

  const setImage = (value: string) => {
    const image = getImage(value);
    setSelectedImage(image);
    image && onChange(image);
  };

  useEffect(() => {
    templateImage && setSelectedImage(templateImage);
  }, [templateImage]);
  return (
    <div className="form-content step-3">
      <div className="container__top">
        <div>
          <h1 className="title-page"> {templateName}</h1>
          <p>{t("createTemplate.imgTemplate.subtitle")}</p>
        </div>
      </div>
      <div>
        <SnackChip
          filters
          handleCLick={() => setFilter("ALL")}
          isActive={"ALL" === filterCategory}
          theme="filters"
          label={t(`home.questions.filters.${"all"}`)}
        />
        {Object.entries(CORE)
          .map(([key, value]) => ({ key, value }))
          .map((item, index) => (
            <SnackChip
              key={index}
              filters
              handleCLick={() => setFilter(item.value)}
              isActive={item.value === filterCategory}
              theme="filters"
              label={t(`home.questions.filters.${item.value}`)}
            />
          ))}
      </div>
      <div className="wrapper-images row">
        {imagesArray &&
          Object.entries(imagesArray).map(([item, value], index) => {
            return (
              <div
                key={index}
                className="col-lg-4 col-xl-3 col-xxl-2 mt-4 wrapper-image"
              >
                <div
                  onClick={() => setImage(item)}
                  className={`container-image ${getClasses({
                    "is-selected": getImage(item) === selectedImage,
                  })}`}
                >
                  <img className="image" alt={item} src={value}></img>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default React.memo(Step3);
